import React from 'react';

class EsqueceuSenhaForm extends React.Component {

    render() {
        return(
            <div id="esqueceu-senha-form">
                <p id="esqueceu-senha-txt">
                    Informe o seu E-mail para recuperar a sua senha.
                </p>
                <form>
                    <input type="text"
                        placeholder="E-mail"
                        value={ this.props.email }
                        onChange={ this.props.changeEmail } /><br />
                    <button type="button" onClick={ this.props.enviar }>
                        Enviar
                    </button>
                    <button type="button" onClick={ this.props.cancelar }>
                        Cancelar
                    </button>
                    <p id="esqueceu-senha-err-msg">{ this.props.errMsg }</p>
                </form>
            </div>
        );
    }

}

export default EsqueceuSenhaForm;

